import PointSettingAchieveList from '@/component/point/achieve/list';
import RegisterAchieve from '@/component/point/achieve/register';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PointSettingAchieve() {
  const {
    state: { settingId },
  } = useLocation();

  const [refresh, setRefresh] = useState(0);
  const handleApiSuccess = () => {
    setRefresh((prev) => prev + 1); // 값만 바꿔주면 Child2가 리렌더링됨
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        <RegisterAchieve settingId={settingId} onSuccess={handleApiSuccess} refresh={refresh} />
        <Box mb={10} />

        <PointSettingAchieveList settingId={settingId} refresh={refresh} />
      </Box>
    </>
  );
}

/**
 * 등록, 리스트
 *
 * 등록 할 때 멘트도 함께 나오게 해야 한다
 *
 * 화면 구성은??
 * 수량, usdt, 설명1, 설명2
 *
 */
